<template>
  <div class="container">
    <div class="row">
      <transition name="fade">
        <div v-if="userLoading === true" class="loading">
          <div class="loading-icon">
            <fa icon="sync-alt" spin/>
          </div>
          <div class="loading-text">
            Loading preferences...
          </div>
        </div>
      </transition>
      <div class="col-sm-6">
        <h3>Show Teams</h3>
        <draggable class="list-group dragArea" v-model="selectedTeams" :options="{group:'TEAMS'}">
          <div
            class="list-group-item"
            v-for="team in selectedTeams"
            :key="team.name"
          >
            {{ team.name }}
          </div>
        </draggable>
      </div>

      <div class="col-sm-6">
        <h3>Hide Teams</h3>
        <draggable class="list-group dragArea" v-model="unselectedTeams" :options="{group:'TEAMS'}">
          <div
            class="list-group-item"
            v-for="team in unselectedTeams"
            :key="team.name"
          >
            {{ team.name }}
          </div>
        </draggable>
      </div>
      <div class="col-sm-12 text-left">
        <h6>Select where you would like to be redirected after closing a message:</h6>
        <b-form-select v-model="messageRedirect" :options="options">
        </b-form-select>
      </div>
      <div class="col-sm-12 text-left">
        <h6>Custom fileds to be displayed on client's page</h6>
        <multiselect v-model="fieldsOrder" :multiple="true" :options="fieldsCollection"/>
      </div>
      <div class="col-sm-12 text-left">
        <h6>Preferred</h6>
        <multiselect v-model="preferredBoards" :multiple="true" :options="boards" label="name" track-by="name"  />
      </div>
    </div>
    <a class="btn" @click="handleSubmit">Update</a>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {mapGetters, mapActions, mapMutations} from 'vuex'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    draggable,
    Multiselect
  },
  data () {
    return {
      options: [
        { value: 0, text: 'Unassigned' },
        { value: 1, text: 'Mine' },
        { value: 2, text: 'Previous' }
      ],
      boards: []
    }
  },
  display: 'Two Lists',
  order: 1,
  computed: {
    ...mapGetters(['currentUser', 'fields', 'userLoading', 'teams']),
    fieldsOrder: {
      get () {
        return this.currentUser.fields_order
      },
      set (value) {
        this.updateUserProperties({fields_order: value})
      }
    },
    preferredBoards: {
      get () {
        let selected = this.boards.filter(board => this.currentUser.preferred_boards.includes(board.value))
        return selected.map((board) => { return {name: board.name, value: board.value} })
      },
      set (value) {
        let boardIds = value.map(board => board.value)
        this.updateUserProperties({preferred_boards: boardIds})
      }
    },
    messageRedirect: {
      get () {
        return this.currentUser.message_redirect
      },
      set (value) {
        this.updateUserProperties({message_redirect: value})
      }
    },
    selectedTeams: {
      get () {
        let selected = this.teams.filter(team => this.currentUser.filtered_teams.includes(team.id))
        selected = this.mapOrder(selected, this.currentUser.filtered_teams, 'id')
        return selected
      },
      set (value) {
        this.updateUserProperties({filtered_teams: value.map(team => team.id)})
      }
    },
    unselectedTeams: {
      get () {
        return this.teams.filter(team => !this.currentUser.filtered_teams.includes(team.id))
      },
      set () {
        // we dont need setter
      }
    },
    fieldsCollection () {
      return this.fields.map(f => f.name)
    }
  },
  created () {
    this.loadFields()
    this.setUser()
    this.getBoards()
  },
  methods: {
    ...mapActions(['loadFields', 'updateUser']),
    ...mapMutations(['updateUserProperties']),
    setUser () {
      this.selected = this.currentUser.message_redirect
    },
    mapOrder (array, order, key) {
      array.sort(function (a, b) {
        var A = a[key]
        var B = b[key]
        if (order.indexOf(A) > order.indexOf(B)) {
          return 1
        } else {
          return -1
        }
      })
      return array
    },
    handleSubmit (e) {
      e.preventDefault()
      this.updateUser()
    },
    getBoards () {
      this.$http
        .get('/boards', { params: { user_id: this.currentUser.id } })
        .then(response => {
          this.boards = response.data.map(function mapBoard (board) {
            return {name: board.name, value: board.id}
          })
        })
    }
  }
}
</script>

<style scoped>
.list-group {
  border: 1px solid #57B2CD;
  min-height: 50px;
}
.btn {
  margin-top: 20px;
  color: #fff !important;
  background: #57B2CD;
}
.btn:hover {
  background: #4697AF;
}
.col-sm-12.text-left {
  margin-top: 20px;
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  padding: 5vw;
  text-align: center;
  font-size: calc(~"15px + 1.5vw");
  background-color: #fff;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/UserPreferences.vue